import { createSidetab } from '@typeform/embed'
import '@typeform/embed/build/css/sidetab.css'

export default (formId, buttonText) => ({
  init() {
    const { toggle } = createSidetab(formId, { buttonText: buttonText })
    this.open = toggle
  },
})
